module.exports = {
	...require("./acCommon"),
	...require("./acBookingFlow"),
	...require("./acLogin"),
	...require("./acAuth"),
	...require("./acSignup"),
	...require("./acBookings"),
	...require("./acBookingDetails"),
	...require("./acAccountProfile"),
	...require("./acAccountSecurity"),
	...require('./acAccountPrivacy'),
	...require('./acResidences'),
	...require('./acUserAffiliate'),
	...require('./acAffiliatePage'),
	...require('./acLanding'),
}



// WEBPACK FOOTER //
// ./src/actions/allActions.js